// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-80547cfe]{border-collapse:collapse}table[data-v-80547cfe],td[data-v-80547cfe],th[data-v-80547cfe]{border:.5px solid #000}thead[data-v-80547cfe]{display:table-row-group}tr td[data-v-80547cfe]{page-break-inside:avoid}.no-border[data-v-80547cfe]{border:none!important}.border-light[data-v-80547cfe]{border:.5px solid grey!important;padding-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
